import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';

export default function ProfileCard() {
  const queryClient = useQueryClient();
  const { data: profile } = useQuery({ queryKey: ['profile'], queryFn: api.getProfile });
  const [profileForm, setProfileForm] = useState(null);
  const [profileMsg, setProfileMsg] = useState(null);
  const pf = profileForm || {
    birth_date: profile?.birth_date || '', sex: profile?.sex || 'M', height_cm: profile?.height_cm ?? '', profile_weight: profile?.profile_weight ?? '',
  };
  const saveProfile = useMutation({
    mutationFn: (payload) => api.updateProfile(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      queryClient.invalidateQueries({ queryKey: ['achievements'] });
      setProfileForm(null);
      setProfileMsg('Profil enregistré');
    },
    onError: (e) => setProfileMsg(e.message),
  });

  const age = (() => {
    if (!pf.birth_date) return null;
    const b = new Date(`${pf.birth_date}T12:00:00`);
    const n = new Date();
    let a = n.getFullYear() - b.getFullYear();
    if (n.getMonth() < b.getMonth() || (n.getMonth() === b.getMonth() && n.getDate() < b.getDate())) a -= 1;
    return a;
  })();

  return (
      <div className="card" style={{ marginBottom: 24 }}>
        <div className="card-title" style={{ marginBottom: 4 }}>Profil (standards de force)</div>
        <p className="muted small" style={{ marginBottom: 12 }}>Utilisé pour calculer tes niveaux de force. Le poids ci-dessous ne sert que tant qu'aucune pesée n'est enregistrée.</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setProfileMsg(null);
            saveProfile.mutate({
              birth_date: pf.birth_date || null,
              sex: pf.sex,
              height_cm: pf.height_cm === '' ? null : parseFloat(pf.height_cm),
              profile_weight: pf.profile_weight === '' ? null : parseFloat(pf.profile_weight),
            });
          }}
        >
          <div className="form-row" style={{ marginBottom: 12 }}>
            <div className="form-group">
              <label className="form-label" htmlFor="profile-birth">Date de naissance{age != null ? ` (${age} ans)` : ''}</label>
              <input id="profile-birth" type="date" className="form-input" value={pf.birth_date} onChange={(e) => setProfileForm({ ...pf, birth_date: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="profile-sex">Sexe</label>
              <select id="profile-sex" className="form-input" value={pf.sex} onChange={(e) => setProfileForm({ ...pf, sex: e.target.value })}>
                <option value="M">Homme</option>
                <option value="F">Femme</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="profile-height">Taille (cm)</label>
              <input id="profile-height" type="number" inputMode="decimal" min="100" max="250" className="form-input" value={pf.height_cm} onChange={(e) => setProfileForm({ ...pf, height_cm: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="profile-weight">Poids de repli (kg)</label>
              <input id="profile-weight" type="number" inputMode="decimal" step="0.1" min="20" className="form-input" value={pf.profile_weight} onChange={(e) => setProfileForm({ ...pf, profile_weight: e.target.value })} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button className="btn btn-primary" type="submit" disabled={saveProfile.isPending}>Enregistrer le profil</button>
            {profileMsg && <span className="muted small">{profileMsg}</span>}
          </div>
        </form>
      </div>
  );
}
